import { Typography, Button, Box, Container, IconButton } from "@mui/material";
import React from "react";
import MainLayout from "../../Main/MainLayout";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { tryHistoryPush } from "../../Main/Main";

export default function ApplicationDiscarded() {
  return (
    <MainLayout containerProps={{ maxWidth: "xl" }} hideHeader>
      <Container>
        <Box
          sx={{
            display: "flex",
            flex: 1,
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <IconButton color="success" size="large">
            <CheckCircleIcon color="success" sx={{ fontSize: 40 }} />
          </IconButton>

          <Typography variant="h4" sx={{ mb: 2 }}>
            Your application has been discarded successfully.
          </Typography>
          <Button
            // variant="text"
            sx={{ fontWeight: "bold" }}
            onClick={() => {
              tryHistoryPush("/");
            }}
          >
            Back to home
          </Button>
        </Box>
      </Container>
    </MainLayout>
  );
}
